import Cropper from "@/lib/components/Cropper";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {CropResponse, MyAccount, SetThumbnailRequest, ThumbnailSize, UploadResponse} from "@/lib/types";
import {dataRetryPolicy, fetchBackend, fetchBackendNoContent} from "@/lib/backend";
import ErrorPage from "@/lib/components/ErrorPage";
import SpinnerPage from "@/lib/components/SpinnerPage";
import {useSession} from "@/lib/auth/auth";
import {BASE_URL} from "@/lib/constants";
import {useRouter} from "expo-router";

export default function ProfileCropper() {
    const {session} = useSession();
    const router = useRouter();
    const queryClient = useQueryClient();

    const {data, isPending, error} = useQuery<MyAccount>({
        queryKey: ['account', session],
        queryFn: () => fetchBackend(`/account`, "GET", session),
        retry: dataRetryPolicy,
    })

    if (error) {
        return <ErrorPage error={error}/>
    } else if (isPending) {
        return <SpinnerPage/>;
    }

    function onCrop(crop: CropResponse) {
        const payload: SetThumbnailRequest = {
            thumbnail_id: crop.thumbnail_id,
        };
        fetchBackendNoContent("/account", "PATCH", session, payload).then(async () => {
            await queryClient.invalidateQueries({queryKey: ['account', session]});
            router.dismiss();
        }).catch((err) => {
            console.error("set thumbnail", err);
        });
    }

    function imageSource(): UploadResponse | undefined {
        if (data && data.avatar_original_url && data.avatar_id) {
            return {
                image_url: BASE_URL + data.avatar_original_url,
                picture_id: data.avatar_id,
            }
        }
    }

    return (
        <Cropper
            source={imageSource()}
            sizeType={ThumbnailSize.AVATAR}
            onCrop={onCrop}
        />
    );
}